export const MY_POSTS_PATH = "/my-posts";
